module.exports = __webpack_public_path__ + "assets/img/qq-dbb282e6.png";